import { onAuthStateChanged } from 'firebase/auth';
import axios from 'utils/axios';
import { auth } from '../../../firebase';
import { v4 as uuidv4 } from 'uuid';

const scheduleAccountForDeletion = (
  orgId,
  orgName,
  reason,
  deleteFlag,
  callback,
) => {
  return async (dispatch) => {
    dispatch({ type: 'SCHEDULING_ACCOUNT_FOR_DELETION' });
    try {
      let unsubscribe = onAuthStateChanged(auth, async (user) => {
        const token = await user?.getIdToken();
        const userInfo = localStorage.getItem('userInfo');
        const userId = JSON.parse(userInfo)?.id;
        const reqId = uuidv4();
        try {
          const response = await axios.delete(
            `/ads/mngmnt/orgs/${orgId}/disable/scheduled`,
            {
              params: {
                requestId: reqId,
                delete: deleteFlag,
                reason,
                orgName,
              },
              headers: {
                Authorization: `Bearer ${token}`,
              },
            },
          );
          if (response.status === 200) {
            await dispatch({
              type: 'SCHEDULING_ACCOUNT_FOR_DELETION_DONE',
              payload: {
                document: response?.data,
              },
            });
            if (typeof callback === 'function') {
              callback(response?.data);
            }
          } else {
            dispatch({
              type: 'SCHEDULING_ACCOUNT_FOR_DELETION_FAILED',
              payload: `Failed to schedule account for deletion`,
            });
          }
        } catch (e) {
          dispatch({
            type: 'SCHEDULING_ACCOUNT_FOR_DELETION_FAILED',
            payload: `Failed to schedule account for deletion`,
          });
        }
        unsubscribe();
      });
    } catch (e) {
      dispatch({
        type: 'SCHEDULING_ACCOUNT_FOR_DELETION_FAILED',
        payload: `Failed to schedule account for deletion`,
      });
    }
  };
};

export default scheduleAccountForDeletion;
